import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { calculatePlanPrice } from 'utils/billing';
import { MONTHLY_INTERVAL } from 'constants/plans';
import PlanBasicInfo from 'components/SubscriptionPicker/PlanBasicInfo';

import { PlanWrapper, SinglePlanCTAButton as CTAButton } from './styled';

const SALES_PURCHASE_MODAL_APPCUES_FLOW_ID = '-LerJ1l3alV9we_zskMj';

function Plan({ index, plan, planLimit, selfService, stripeId, user }) {
  const history = useHistory();
  const [planInterval, setPlanInterval] = useState(MONTHLY_INTERVAL);
  const [price, setPrice] = useState(MONTHLY_INTERVAL);

  const handleIntervalChange = interval => {
    setPlanInterval(interval);
  };

  useEffect(() => {
    setPrice(calculatePlanPrice({ planInterval, plan, planLimit }));
  }, [planInterval, calculatePlanPrice, planLimit]);

  return (
    <PlanWrapper key={`${plan.id}-${index}`} className="planWrapper">
      <PlanBasicInfo
        plan={plan}
        planLimit={planLimit}
        price={price}
        planInterval={planInterval}
        selfService={selfService}
        // Ignore for plans that are not self-served
        onChangeInterval={selfService ? handleIntervalChange : null}
      />

      {selfService ? (
        <CTAButton
          disabled={!stripeId}
          type="positive"
          onClick={() =>
            history.push(
              `/subscription/essentials?pp=${plan.id}&&pl=${planLimit}&pi=${planInterval}&em=${user.email}&st=${stripeId}`
            )
          }
        >
          Upgrade
        </CTAButton>
      ) : (
        <CTAButton
          type="primary"
          onClick={() =>
            window.Appcues &&
            window.Appcues.show(SALES_PURCHASE_MODAL_APPCUES_FLOW_ID)
          }
        >
          Contact Sales
        </CTAButton>
      )}
    </PlanWrapper>
  );
}

Plan.propTypes = {
  index: PropTypes.number,
  plan: PropTypes.shape({
    id: PropTypes.string,
    pricePlanId: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    visible: PropTypes.bool,
    color: PropTypes.string,
    gradient: PropTypes.string,
    featuresCaption: PropTypes.string,
    features: PropTypes.object,
  }),
  planLimit: PropTypes.number,
  selfService: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
  stripeId: PropTypes.string,
  user: PropTypes.object,
};

export default Plan;
